import { isStaffRole } from "@saleor/auth/hooks/useUserRole";
import ActionDialog from "@saleor/components/ActionDialog";
import Container from "@saleor/components/Container";
import MyTypography from "@saleor/components/MyTypography";
import PageHeader from "@saleor/components/PageHeader";
import CreateOrderSuccess from "@saleor/createOrder/components/CreateOrderSuccess";
import SoldToPage from "@saleor/createOrder/components/SoldToPage";
import { contractUrl } from "@saleor/createOrder/urls";
import useNavigator from "@saleor/hooks/useNavigator";
import { OrderListUrlQueryParams } from "@saleor/orders/urls";
import React, { useState } from "react";
import { useIntl } from "react-intl";

interface SoldToListProps {
  params: OrderListUrlQueryParams;
}

const SoldToView: React.FC<SoldToListProps> = () => {
  const [searchId, setSearchId] = useState("");
  const [action, setAction] = useState("");
  const navigate = useNavigator();
  const [open, setOpen] = useState(false);
  const [order, setOrder] = useState(false);
  const [createOrder, setCreateOrder] = useState(false);
  const intl = useIntl();

  const handleSeach = (id: string) => {
    navigate(contractUrl(id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleConfirm = () => {
    setOpen(false);
    setAction("order-summary");
  };
  const handleCloseOrder = () => {
    setOrder(false);
  };
  const handlesSubmitOrder = () => {
    setOrder(false);
    setCreateOrder(true);
  };
  const handleResetAll = () => {
    setCreateOrder(false);
    setAction("");
    setSearchId("");
  };
  return (
    <>
      <Container>
        {!createOrder ? (
          <>
            <PageHeader
              title={
                isStaffRole()
                  ? intl.formatMessage({ defaultMessage: "ค้นหาลูกค้า" })
                  : intl.formatMessage({ defaultMessage: "My Contract" })
              }
            />
            {!action ? (
              <SoldToPage onchange={handleSeach} searchId={searchId} />
            ) : null}
          </>
        ) : (
          <CreateOrderSuccess onReset={handleResetAll} />
        )}
      </Container>
      <ActionDialog
        open={open}
        onClose={handleClose}
        onConfirm={handleConfirm}
        title={<MyTypography variant="h6">ไม่สามารถดำเนินการได้</MyTypography>}
        confirmButtonState="success"
        confirmButtonLabel="กลับไป"
        showBackButton={false}
      >
        <MyTypography variant="body2">
          รายการที่คุณเลือก ยังไม่ได้กรอกรายละเอียดครบถ้วน กรุณาตรวจสอบอีกครั้ง
        </MyTypography>
      </ActionDialog>
      <ActionDialog
        open={order}
        onClose={handleCloseOrder}
        onConfirm={handlesSubmitOrder}
        title={<MyTypography variant="h6">เกิดข้อผิดพลาด!</MyTypography>}
        confirmButtonState="success"
        confirmButtonLabel="ตกลง"
        showBackButton={false}
      >
        <MyTypography variant="body2">
          ไม่สามารถดำเนินการได้ในขณะนี้ กรุณาลองใหม่อีกครั้ง
        </MyTypography>
      </ActionDialog>
    </>
  );
};

export default SoldToView;
